<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
var $ = require('jquery')

export default {
  name: 'app'
}
$(document).ready(function ($) {
  // var windowH = $(window).height()

  // $('#app').height(windowH)

  $.getScript('https://abroad.indstate.edu/wp-includes/js/plupload/plupload.full.min.js?ver=2.1.8', function () {
    $.getScript('https://abroad.indstate.edu/wp-includes/js/jquery/jquery.js?ver=1.12.4', function () {
      $.getScript('https://abroad.indstate.edu/wp-content/plugins/gravityforms/js/gravityforms.min.js?ver=2.0.6')
      $.getScript('https://abroad.indstate.edu/wp-content/plugins/gravityforms/js/placeholders.jquery.min.js?ver=2.0.6')
      $.getScript('https://abroad.indstate.edu/wp-includes/js/jquery/jquery-migrate.min.js?ver=1.4.1')
      $.getScript('https://abroad.indstate.edu/wp-content/plugins/gravityforms/js/jquery.json.js?ver=2.0.6')
    })
    /* <![CDATA[
    var gform_gravityforms = {'strings': {'invalid_file_extension': 'This type of file is not allowed. Must be one of the following: ', 'delete_file': 'Delete this file', 'in_progress': 'in progress', 'file_exceeds_limit': 'File exceeds size limit', 'illegal_extension': 'This type of file is not allowed.', 'max_reached': 'Maximum number of files reached', 'unknown_error': 'There was a problem while saving the file on the server', 'currently_uploading': 'Please wait for the uploading to complete', 'cancel': 'Cancel', 'cancel_upload': 'Cancel this upload', 'cancelled': 'Cancelled'}, 'vars': {'images_url': 'http://isustudyabroad.staging.wpengine.com/wp-content/plugins/gravityforms/images'}}
    /* ]]> */
  })
})
// $(window).resize(function () {
//   var windowH = $(window).height()
//   $('#app').height(windowH)
// })
</script>

<style>
@import 'https://fonts.googleapis.com/css?family=Muli';
@import 'https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css';
html {
  overflow-x: hidden;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  color: #2c3e50;
  margin-top: 60px;
  max-width: 100%;
  overflow-x: hidden;
}
.gform_confirmation_wrapper, .gform_wrapper {
  margin-bottom: 100px !important;
}
textarea {
  resize: none;
}
input[type=email], input[type=text], select, textarea, input {
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// App.vue?edef30ba